import { gql } from "@/__generated__/gql";

export const UPDATE_RISE_ACTION_STATUSES = gql(`
  mutation UpdateRiseActionStatuses(
    $riseActionId: ID!
    $status: RiseUserActionStudentStatusEnum!
    $ids: [ID!]!
  ) {
    bulkUpdateRiseUserActionStudentStatusMutation(input: {
      argument: {
        updateIds: {
          riseUserActionId: $riseActionId
          riseUserActionStudentStatusIds: $ids
          status: $status
        }
      }
    }) {
      clientMutationId
      errors {
        title
        message
      }
    }
  }
  `);
